import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import sectioncard1 from "../../../assets/img/sectioncard1.png";
import logoJMD from "../../../assets/img/logo-jmd.png";
import logokemenag from "../../../assets/img/logo-kemenang.png";

const HARDCODED = {
	title: "Dapatkan Harga Spesial!!",
	subtitle:
		"Dan dapatkan benefit lainnya!! Bergabunglah dengan ribuan madrasah yang telah bertransformasi digital.",
	buttonText: "Hubungi Kami Sekarang",
	buttonLink: "https://wa.me/6287739532870",
};

function CTASection() {
	const [isVisible, setIsVisible] = useState(false);
	const [data, setData] = useState(HARDCODED);
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.15 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		axios
			.get("/api_w/abouts", {
				params: { title: "home:cta" },
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const item = res.data.data?.[0];
				if (item?.body) {
					const parsed = JSON.parse(item.body);
					if (parsed?.title) setData(parsed);
				}
			})
			.catch(() => {});
	}, []);

	return (
		<section aria-label="Call to Action" ref={sectionRef} className="py-20 px-4">
			<div className="max-w-7xl mx-auto">
				<div
					className={`relative overflow-hidden rounded-[3rem] min-h-[400px] flex items-center shadow-2xl transition-all duration-1000 ${
						isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
					}`}
				>
					<div className="absolute inset-0 z-0">
						<img
							src={sectioncard1}
							alt="CTA Background"
							className="w-full h-full object-cover"
						/>
						<div className="absolute inset-0 bg-gradient-to-r from-green-900/90 via-green-800/80 to-transparent" />
					</div>

					<div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-96 h-96 bg-green-500 rounded-full blur-3xl opacity-50" />
					<div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-64 h-64 bg-green-400 rounded-full blur-3xl opacity-30" />

					<div className="relative z-10 p-8 md:p-24 w-full lg:max-w-2xl">
						<div className="flex items-center gap-3 mb-6">
							<img
								className="h-12 w-auto object-contain drop-shadow-[0_2px_8px_rgba(255,255,255,0.05)] transition-all duration-500 hover:scale-105"
								src={logoJMD}
								alt="Logo JMD"
							/>
							<img
								className="h-12 w-auto object-contain drop-shadow-[0_2px_8px_rgba(255,255,255,0.05)] transition-all duration-500 hover:scale-105"
								src={logokemenag}
								alt="Logo Kemenag"
							/>
						</div>

						<h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-[1.1]">
							{data.title}
						</h2>
						<p className="text-green-100 text-lg md:text-xl mb-10 opacity-90 font-medium">
							{data.subtitle}
						</p>

						<div className="flex flex-col sm:flex-row items-center gap-5">
							<a
								href={data.buttonLink || HARDCODED.buttonLink}
								target="_blank"
								rel="noopener noreferrer"
								className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-400 text-white font-bold px-10 py-4 rounded-full shadow-lg shadow-green-500/30 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 text-base"
							>
								{data.buttonText || HARDCODED.buttonText}
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default CTASection;
